// import { API_URL, API_URL_SUFFIX } from "@/constants/api";
// import { extractProps } from "@/utils/api";
import { createFileRoute } from "@tanstack/react-router";
import Component from "@/routes/(pharma)/_layout/inventory/available-inventory/-components/component";
import { SearchParams } from "./-data/model";
import { getAvailableMedicalInventory, getAvailableMedicalInventoryExpired, getAvailableMedicalInventoryExpiring, getAvailableNonMedicalInventory, getAvailableNonMedicalInventoryExpired, getAvailableNonMedicalInventoryExpiring } from "./-data/api";
import { InventorySchema } from "./-data/type";
import { Loading } from "@/layouts/loading";
import { GetInventoryResponse } from "@/gen/inventory/get_inventory_pb";
import { pharmacyClient } from "@/connect";
import { ItemType } from "@/gen/inventory/common_pb";

export const Route = createFileRoute("/(pharma)/_layout/inventory/available-inventory/")({
    component: Component,
    validateSearch: SearchParams,
});